/* eslint-disable no-restricted-globals */
import { useEffect, useState } from "react";
import { nanoid } from "nanoid";
import completedImage from "../Assets/completed.jpg";
import AddTaskComponent from "./AddTaskComponent";
import { getProjectById, getProjectCounts } from "../Services/GetProjects";
import { IoIosSave, IoIosLogOut } from "react-icons/io";
import { MdAddCircle, MdInvertColors, MdClearAll, MdAccountCircle } from "react-icons/md";
import TaskCard from "./TaskCard";
import "./KanbanStyle.scss";
import Swal from "sweetalert2/dist/sweetalert2.all";
import { saveProject } from "../Services/UpdateProject";
import ConfettiComponent from "./ConfettiComponent";
import { getUserDetails, logoutUser } from "../Services/login";
import ProfileComponent from "./ProfileComponent";

/*
  Page used to render Kanban page for specific project
*/

const KanbanComponent = ({ id, isDark }) => {
  // Declaring the states for component
  const [dbName, setDbName] = useState("");
  const [taskText, setTaskText] = useState("");
  const [isLoading, setLoading] = useState(true);
  const [pOpen, setPOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [dbId, setDbId] = useState("");
  const [notStarted, setNotStarted] = useState([]);
  const [progress, setProgress] = useState([]);
  const [confettiOpen, setCOpen] = useState(false);
  const [completed, setCompleted] = useState([]);

  useEffect(() => {
    // Get the id parameter from the URL eg: /kanban/{id}
    setDbId(id);
    console.log("from kanban :" + id);
    // call getProjectById() function
    // in /Services/GetProjects.js
    const db = getProjectById(id);
    // Set the corresponding states like
    if (db) {
      setDbName(db.projectName); // ProjectName
      setCompleted(db.projectBody.completed); // List of completed tasks
      setProgress(db.projectBody.inProgress); // List of tasks in progress
      setNotStarted(db.projectBody.notStarted); // List of tasks not started
      setLoading(false); // Loading status
    }
  }, [id]); // setting dependencies as dbId and match prop

  const showConfetti = () => {
    setCOpen(true);
    setTimeout(() => {
      setCOpen(false);
    }, 4000);
  };

  /*
    Function that is triggered when save button is clicked
  */
  const saveData = () => {
    console.log({ dbName, dbId, notStarted, progress, completed });
    // call saveProject() function found in
    // /Services/UpdateProject.js
    saveProject(dbName, dbId, notStarted, progress, completed);
  };

  /*
    Function that is called when ever a card drop event is 
    performed
  */

  const onCardDrop = (e) => {
    // preventing the default event
    e.preventDefault();
    // getting project text to transfer
    let data = e.dataTransfer.getData("text");
    // getting project id to transfer
    let id = e.dataTransfer.getData("id");
    // creating a task structure
    let theTask = {
      id: id,
      task: data,
    };
    // get parent element information
    let parentData = e.dataTransfer.getData("parent");
    console.log(parentData);
    // if the parent and target are same
    if (e.target.id === parentData) {
      return;
    }
    // lets add the task to target state
    if (e.target.id === "complete") {
      addToCompleted(theTask);
    }
    if (e.target.id === "nstart") {
      addToNotStarted(theTask);
    }
    if (e.target.id === "prog") {
      addToProgress(theTask);
    }
    // remove the task from parent state
    if (parentData === "nstart") {
      removeFromNotStarted(id);
    }
    if (parentData === "prog") {
      removeFromProgress(id);
    }
    if (parentData === "complete") {
      removeFromCompleted(id);
    }
    saveData();
  };

  const allowDrop = (e) => {
    e.preventDefault();
  };

  /*
    Function used to clear out all the task completed
  */

  const clearCompleted = () => {
    Swal.fire({
      imageUrl: completedImage,
      imageHeight: 260,
      imageAlt: "Completed Tasks",
      title: "Hurray, Tasks completed Successfully !",
    });
    setCompleted([]);
    showConfetti();
  };

  /*
    Function triggered on a card is started to drag
  */

  const onCardDrag = (e) => {
    // get the id and task text
    let [taskId, taskName] = e.target.id.toString().split(":");
    // store for event data transfer
    // this data is needed to locate the tasks while droping
    e.dataTransfer.setData("id", taskId);
    e.dataTransfer.setData("text", taskName);
    e.dataTransfer.setData("parent", e.target.parentNode.id);
    console.log(taskName);
  };

  // Function to add task to completed tasks list
  const addToCompleted = (task) => {
    let temp = completed;
    temp = [...completed, task];
    setCompleted(temp);
  };

  // Function to add task to inprogress tasks list
  const addToProgress = (task) => {
    let temp = progress;
    temp = [...progress, task];
    setProgress(temp);
  };

  // Function to add task to non-started tasks list
  const addToNotStarted = (task) => {
    let temp = notStarted;
    temp = [...notStarted, task];
    setNotStarted(temp);
  };

  // Function to remove the task from non-started tasks list
  const removeFromNotStarted = (taskId) => {
    let temp = notStarted.filter((e) => e.id !== taskId);
    setNotStarted(temp);
  };

  // Function to remove the task from inprogress tasks list
  const removeFromProgress = (taskId) => {
    let temp = progress.filter((e) => e.id !== taskId);
    setProgress(temp);
  };

  // Function to remove the task from completed tasks list
  const removeFromCompleted = (taskId) => {
    let temp = completed.filter((e) => e.id !== taskId);
    setCompleted(temp);
  };

  // Function used to toggle the dark mode
  const toggleTheme = () => {
    if (isDark) {
      localStorage.removeItem("isDark");
    } else {
      localStorage.setItem("isDark", "yes");
    }
    location.reload();
  };

  // return the UI in form of JSX
  return (
    <>
      <ConfettiComponent open={confettiOpen} />
      <div className={`kanban-parent ${isDark ? "kanban-parent-dark" : ""}`}>
        <div className="heading">
          <h1>{dbName}</h1>
          <div className="project-title">
            <button onClick={clearCompleted} className="icn-btn">
              <MdClearAll size={22} />
              &nbsp; Clear tasks
            </button>
            <button onClick={saveData} className="icn-btn">
              <IoIosSave size={22} />
            </button>
            <button onClick={toggleTheme} className="icn-btn">
              <MdInvertColors size={22} />
            </button>
            <button onClick={() => setPOpen(true)} className="icn-btn">
              <MdAccountCircle size={22} />
            </button>
            <button onClick={() => logoutUser()} className="icn-btn">
              <IoIosLogOut size={22} />
            </button>
          </div>
        </div>
        <div className="kanban-wrap">
          <div
            id="nstart"
            className={`kanban-section ${
              isDark ? "kanban-section-dark" : ""
            } notstarted`}
            onDrop={onCardDrop}
            onDragOver={allowDrop}
          >
            <div className="kanban-section-heading">
              <h2>Todo</h2>
              <div className="chip-holder">
                <span className="chip">{notStarted.length}</span>
                <button
                  className={`icn-btn-nobg ${
                    isDark ? "icn-btn-nobg-dark" : ""
                  }`}
                  onClick={() => setOpen(true)}
                >
                  <MdAddCircle size={22} />
                </button>
              </div>
            </div>
            {isLoading ? (
              <p>loading</p>
            ) : (
              notStarted.map((data, key) => (
                <TaskCard
                  key={key}
                  isDark={isDark}
                  id={`${data.id}:${data.task}`}
                  onDrag={onCardDrag}
                  taskName={data.task}
                />
              ))
            )}
          </div>
          <div
            className={`kanban-section ${
              isDark ? "kanban-section-dark" : ""
            } progress`}
            id="prog"
            onDrop={onCardDrop}
            onDragOver={allowDrop}
          >
            <div className="kanban-section-heading">
              <h2>In Progress</h2>
              <div className="chip-holder">
                <span className="chip">{progress.length}</span>
              </div>
            </div>

            {isLoading ? (
              <p>loading</p>
            ) : (
              progress.map((data, key) => (
                <TaskCard
                  key={key}
                  isDark={isDark}
                  id={`${data.id}:${data.task}`}
                  onDrag={onCardDrag}
                  taskName={data.task}
                />
              ))
            )}
          </div>
          <div
            id="complete"
            className={`kanban-section ${
              isDark ? "kanban-section-dark" : ""
            } completed`}
            onDrop={onCardDrop}
            onDragOver={allowDrop}
          >
            <div className="kanban-section-heading">
              <h2>Done</h2>
              <div className="chip-holder">
                <span className="chip">{completed.length}</span>
              </div>
            </div>

            {isLoading ? (
              <p>loading</p>
            ) : (
              completed.map((data, key) => (
                <TaskCard
                  key={key}
                  isDark={isDark}
                  id={`${data.id}:${data.task}`}
                  onDrag={onCardDrag}
                  taskName={data.task}
                />
              ))
            )}
          </div>
        </div>
        <AddTaskComponent
          isDark={isDark}
          onTaskChange={(e) => setTaskText(e.target.value)}
          onAddTask={() => {
            setOpen(false);
            addToNotStarted({ id: nanoid(8), task: taskText })}}
          open={open}
          onCancel={() => setOpen(false)}
        />
        <ProfileComponent
          isDark={isDark}
          user={getUserDetails()["name"]}
          dp={getUserDetails()["imageUrl"]}
          email={getUserDetails()["email"]}
          open={pOpen}
          handleClose={() => setPOpen(false)}
          projectCount={getProjectCounts()}
        />
        {/* <button
          id="saveBtn"
          aria-label="add"
          className="fab flex"
          onClick={saveData}
        >
          <IoIosSave size={22} />
          &nbsp;
          <span>Save</span>
        </button> */}
      </div>
    </>
  );
};

export default KanbanComponent;
